import { INormalisedResult } from '../../core/interfaces/interfaces';
import { isInArray } from '../../core/util/is-in-array';
import { isDefined } from 'ionic-angular/util/util';
import { isString } from 'util';
import { schema } from 'normalizr';
import { Field } from '../business-objects/field/field.model';
import { Control } from '../business-objects/control/control.model';
import { File } from '../business-objects/file/file.model';
import { SCHEMA_MAP } from '../../app/app.config.schema-map';
import Entity = schema.Entity;

export class ObjectsHelper {

    static fixMissingProperties(entity, normalisedResult: INormalisedResult): INormalisedResult {

        switch (entity) {
            default:
                return normalisedResult;
        }
    }

    static parseJsonFields(entityType: string, object: any): any {
        switch (entityType) {
            case "field": {

                if (!isDefined(object.value) || !isString(object.value)) {
                    return object;
                }

                if (!isInArray(object.value.substring(0, 1), ["{", "["])) {
                    return object;
                }

                return new Field({
                    ...object,
                    value: ObjectsHelper.parseJsonField(object.value, object.value, object)
                });
            }
            case "file":
                return new File({
                    ...object,
                    config: ObjectsHelper.parseJsonField(object.config, {}, object),
                });
            case "control": {
                return new Control({
                    ...object,
                    config: ObjectsHelper.parseJsonField(object.config, {}, object),
                    defaultValue: ObjectsHelper.parseJsonField(object.defaultValue, object.defaultValue, object)
                });
            }
            default: {
                return object;
            }
        }
    }

    static parseJsonField(json, defaultValue = json, object = {}, property: string = ""): any {
        let value: any;

        if (!json) {
            return defaultValue;
        }

        if (!isString(json)) {
            return json;
        }

        if (isString(json) && !isInArray(json.substring(0, 1), ["{", "["])) {
            return json;
        }

        try {
            value = JSON.parse(json);
        } catch (e) {
            console.warn("failed to parse property '%s' in ", property, object);
            value = defaultValue;
        }
        return value;
    }

    getSchema(entity: string): Entity {

        const schemaMap = SCHEMA_MAP;

        if (typeof schemaMap[entity] === "undefined") {
            throw new Error(`entity name "${entity}" cannot be mapped to a schema. valid objects are: ${Object.keys(schemaMap).join(", ")}`);
        }

        return schemaMap[entity];
    }
}



// WEBPACK FOOTER //
// ./src/vas/helpers/object-helper.ts